import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import '../IssuesPage/IssuesPage.css';

interface AttachmentPreviewProps {
    file: File;
    onRemove: () => void;
}

const AttachmentPreview: React.FC<AttachmentPreviewProps> = ({ file, onRemove }) => {
    return (
        <div className="attachment-preview">
            <span className="attachment-name">{file.name}</span>
            <button onClick={onRemove} className="remove-attachment-btn">
                <FontAwesomeIcon icon={faTimesCircle} />
            </button>
        </div>
    );
};

export default AttachmentPreview;
